import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { debounce } from 'lodash'

import { requestUsers, getUsers } from 'ducks/users'

import Page from 'components/Shared/Page'

import { DEBOUNCE_TIME } from '../../constants'

import { AdminUserOrganization } from './Apps'

import './Admin.scss'

class UserItem extends Component {
  render() {
    const { user } = this.props

    return (
      <Link className="admin-user-item" to={`/admin/users/${user.id}`}>
        <h5>{user.name}</h5>
        <p>{user.email}</p>
        <p>{user.createdAt}</p>
        <p>
          {user.Organizations.map(org => (
            <AdminUserOrganization key={org.id} organization={org} />
          ))}
        </p>
      </Link>
    )
  }
}

class AdminUsers extends Component {
  constructor(props) {
    super(props)

    this.state = {
      value: '',
    }

    this.handleQuery = debounce(this.handleQuery, DEBOUNCE_TIME)
  }

  componentDidMount() {
    const { requestUsers } = this.props

    requestUsers()
  }

  componentDidUpdate(prevProps, prevState) {
    const { value } = this.state
    if (prevState.value !== value) this.handleQuery()
  }

  handleChange = e => {
    e.preventDefault()
    this.setState({ value: e.target.value })
  }

  handleQuery = () => {
    const { requestUsers } = this.props
    const { value } = this.state

    if (!value) return requestUsers()

    return requestUsers({ query: value })
  }

  render() {
    const { users } = this.props
    const { value } = this.state

    return (
      <Page className="admin-users-page" title="Users">
        <Link to="/admin/marketplace">Marketplace Libraries</Link>
        {` • `}
        <Link to="/admin/builds">Builds</Link>
        <section className="users-header">
          <h1>Users</h1>
          <input
            type="text"
            onChange={this.handleChange}
            value={value}
            placeholder="Search by name or email"
            autoFocus
          />
        </section>
        <div className="admin-users-header">
          <p>Name</p>
          <p>Email</p>
          <p>Signup Date</p>
          <p>Team(s)</p>
        </div>
        {users.map(u => (
          <UserItem key={u.id} user={u} />
        ))}
      </Page>
    )
  }
}

const mapStateToProps = state => ({
  users: getUsers(state),
})

export default connect(mapStateToProps, { requestUsers })(AdminUsers)
